import { logout } from '@ad/uc';
import { NormalCopyLine, SystemArrowLargeDownFill, SystemPeopleLine } from '@m-ui/icons';
import { logoutRedirectUrl } from 'common/uc';
import Header from 'components/Header';
import { Avatar, Button, Card, Col, Menu, Popover, Row, Space, Typography } from 'm-ui';
import React, { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { filterAdminRouters, navs as navigations } from 'router';
import Guard from 'router/Guard';
import { globalAction } from 'store/global';
import './index.less';

const GcLayout: FC = (props) => {
  const history = useHistory();
  const { pathname } = useLocation();
  const [selectKeys, setSelectKeys] = useState<string[]>([]);
  const userInfo = useSelector((state) => state.global.userInfo);
  const dispatch = useDispatch();
  const navs = filterAdminRouters(navigations, userInfo?.accountInfo.accountId ?? '');
  useEffect(() => {
    const keys = navs.filter((nav) => pathname.startsWith(nav.path)).map((nav) => nav.path);
    if (keys) {
      setSelectKeys(keys);
    } else {
      setSelectKeys([]);
    }
  }, [pathname]);
  const handleLogout = () => {
    logout(logoutRedirectUrl);
    // logout('/');
    // logout(window.location.origin);
  };
  const kwaiId =
    userInfo?.accountInfo.agentUserId === '0'
      ? userInfo?.accountInfo.accountUserId
      : userInfo?.accountInfo.agentUserId;
  return (
    <>
      <Header>
        <Row style={{ height: 64 }}>
          <Col flex="204px">
            <img
              height="32"
              style={{ marginTop: 16 }}
              src="https://p1-ad.adkwai.com/kos/nlav10972/interactive_editor/logo.410d20d83b4f8465.png"
              alt=""
            />
          </Col>
          <Col flex="auto">
            <Menu
              mode="horizontal"
              className="gc-header-menu"
              selectedKeys={selectKeys}
              onClick={(value) => {
                history.push(value.key);
              }}
            >
              {navs.map((nav) => (
                <Menu.Item key={nav.path}>{nav.meta?.title}</Menu.Item>
              ))}
            </Menu>
          </Col>
          <Col
            flex="288px"
            className="flex"
            style={{ alignItems: 'center', flexDirection: 'row-reverse' }}
          >
            <Popover
              placement="bottomRight"
              content={
                <div className="pop-content" style={{ width: 280 }}>
                  <Card bordered={false} style={{ borderBottom: '1px solid #f0f0f0' }}>
                    <div className="title">登录用户信息</div>
                    <div className="content">
                      <span className="info-label">快手ID</span>
                      <Typography.Text
                        copyable={{
                          tooltips: false,
                          icon: [<NormalCopyLine key="copy-icon" style={{ color: '#8C8C8C' }} />],
                        }}
                      >
                        {kwaiId}
                      </Typography.Text>
                    </div>
                  </Card>
                  <Card bordered={false} style={{ borderBottom: '1px solid #f0f0f0' }}>
                    <div className="title">当前操作的广告账号信息</div>
                    <div className="content">
                      <span className="info-label">账户名</span>
                      <Typography.Text
                        copyable={{
                          tooltips: false,
                          icon: [<NormalCopyLine key="copy-icon" style={{ color: '#8C8C8C' }} />],
                        }}
                      >
                        {userInfo?.accountInfo.userName}
                      </Typography.Text>
                      <br />
                      <span className="info-label">账户ID</span>
                      <Typography.Text
                        copyable={{
                          tooltips: false,
                          icon: [<NormalCopyLine key="copy-icon" style={{ color: '#8C8C8C' }} />],
                        }}
                      >
                        {userInfo?.accountInfo.accountId}
                      </Typography.Text>
                    </div>
                  </Card>
                  <Card bordered={false}>
                    <div className="title">当前广告账号绑定的快手ID</div>
                    <div className="content">
                      <span className="info-label">快手ID</span>
                      <Typography.Text
                        copyable={{
                          icon: [<NormalCopyLine key="copy-icon" style={{ color: '#8C8C8C' }} />],
                        }}
                      >
                        {userInfo?.accountInfo.accountUserId}
                      </Typography.Text>
                    </div>
                  </Card>

                  <div className="operation-wrap">
                    <Button
                      type="link"
                      onClick={() => {
                        dispatch(globalAction.setAgreementVisible(true));
                      }}
                    >
                      查看用户协议
                    </Button>
                    <Button className="btn-logout" onClick={handleLogout} type="text">
                      退出登录
                    </Button>
                  </div>
                </div>
              }
              trigger="hover"
            >
              <Space align="center" style={{ lineHeight: 1 }}>
                <Avatar
                  src={userInfo?.accountInfo.headUrl}
                  icon={<SystemPeopleLine />}
                  style={{ width: 32, height: 32, marginLeft: 18 }}
                />
                <div className="ks-header ellipsis" style={{ maxWidth: 123, lineHeight: 1 }}>
                  {userInfo?.accountInfo.userName}
                </div>
                <SystemArrowLargeDownFill style={{ color: '#8c8c8c' }} />
              </Space>
            </Popover>
          </Col>
        </Row>
      </Header>
      <Guard />
    </>
  );
};

export default GcLayout;
